<app-header [menuList$]="menuList$" [memberInfo$]="memberInfo$"></app-header>

<app-sub-header [currMenu]="currMenu$" [memberInfo]="memberInfo$"></app-sub-header>

<!-- 서브메뉴 탭 구성 //-->
<ng-container *ngIf="(currMenu$ | async)['page_cd'].length > 6 && (currMenu$ | async)['parentNode']['children'].length > 0">
  <ul class="sub-tab inner-wrap">
    <li class="nav-item" *ngFor="let item of (currMenu$ | async)['parentNode']['children']; index as i">
      <a class="cp nav-link" [ngClass]="{active: (currMenu$ | async)['seq'] == item.seq}" (click)="goLink(item)">{{item.page_menu_name}}</a>
    </li>
  </ul>
</ng-container>

<div class="page-header inner-wrap clearfix">
  <div class="title">{{(currMenu$ | async)['page_name']}}</div>
  
  <div class="path">
    <a routerLink="/" class="home">홈</a>
    <span>{{(currMenu$ | async)['parentNode']['page_menu_name']}}</span>
    <span class="now">{{(currMenu$ | async)['page_name']}}</span>
  </div>
</div>

<div class="board-page inner-wrap">
 
  <table class="view-table">
  <colgroup>
    <col class="col1">
    <col>
  </colgroup>
  <tbody>
  <tr>
    <td colspan="2" class="title">
      <ng-container *ngIf="data['detail'] != undefined">
      {{data['detail'].subject}}
      </ng-container>
    </td>
  </tr>
  <tr>  
    <td colspan="2" class="contents">
    <div class="date">
      <div *ngIf="data['detail'] != undefined">조회 {{data['detail'].hit}}</div>
      <div *ngIf="data['detail'] != undefined">{{data['detail'].write_date}}</div>
    </div>
    <ng-container *ngIf="data['detail'] != undefined" >
    <div [innerHTML]="data['detail'].contents | safe: 'html'"></div>
    </ng-container>
  </tr>
  <tr>  
    <th>첨부파일</th>
    <td class="attach-file">
      <ng-container *ngFor="let item of data['upload']">
      <a href="{{item.url}}" target="_blank">{{item.origin}}</a>
      </ng-container>
    </td>
  </tr>   
  </tbody>
  </table>
  
  <div class="btn-area">
    <button class="list-btn" (click)="list()">목록</button>  
  </div>
</div>

<app-footer></app-footer>
